import PayPal3 from './PayPal3'
export default PayPal3
